(() => {
if (customElements.get('md-roadmap')) return;
customElements.define('md-roadmap', class extends HTMLElement {
connectedCallback() { queueMicrotask(() => this.initialize()); }
disconnectedCallback() { this.cleanup?.(); }
initialize() {
  if (this.cleanup) return;
  const root = this;
  const abort = new AbortController();
  const signal = abort.signal;
  const entries = [...root.querySelectorAll('.desktop-entry')];
  const items = entries.map(entry => {
    const img = entry.querySelector('.milestone-photo img');
    const figure = entry.querySelector('.milestone-photo');
    return {date:entry.querySelector('time').textContent.trim(),year:entry.querySelector('time').getAttribute('datetime').slice(0,4),kind:entry.querySelector('.category').textContent,title:entry.querySelector('h2').textContent,copy:entry.querySelector('.entry-copy>p:last-child').textContent,image:img?.getAttribute('src'),alt:img?.alt,caption:entry.querySelector('figcaption')?.textContent || '',fit:figure?.classList.contains('contain')?'contain':'cover',position:'center '+(figure?.style.getPropertyValue('--image-position') || '50%'),background:entry.style.getPropertyValue('--milestone-bg'),text:entry.style.getPropertyValue('--milestone-text')};
  });
  if (!items.length) return;
  const steps = Math.max(1,items.length-1);
  function sizeCards() {
    root.style.setProperty('--card-height', (Number(root.dataset.cardHeight)||320)+'px');
    if (root.getBoundingClientRect().width<=640) return;
    const height=Math.max(Number(root.dataset.cardHeight)||320,...entries.map(entry=>entry.querySelector('.entry-copy').scrollHeight+8));
    root.style.setProperty('--card-height',height+'px');
  }
  const journey = root.querySelector('.mobile-journey');
  const scene = root.querySelector('.journey-scene');
  const sceneBody = root.querySelector('.scene-body');
  const track = root.querySelector('.icon-track');
  const nodes = [...root.querySelectorAll('.mobile-node')];
  const detail = root.querySelector('.chapter-detail');
  const previous = root.querySelector('.previous');
  const next = root.querySelector('.next');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let active = -1, interactive = false, staticMode = false, timer, raf = false, range = 1, sceneHeight = 0, lastWidth = 0, headerHeight = 0, settledIndex = 0, navigationTarget = null, touching = false;
  nodes.forEach((node, index) => node.style.setProperty('--node-index', index));
  function render(index) {
    if (index === active) return;
    active = index;
    const item = items[index];
    root.querySelector('.current-year').textContent = item.year;
    root.querySelector('.current-count').textContent = `${String(index + 1).padStart(2, '0')} / ${items.length}`;
    root.querySelector('#chapter-date').textContent = item.date;
    root.querySelector('#chapter-category').textContent = item.kind;
    root.querySelector('#chapter-title').textContent = item.title;
    root.querySelector('#chapter-copy').textContent = item.copy;
    detail.style.setProperty('--milestone-bg',item.background);
    detail.style.setProperty('--milestone-text',item.text);
    detail.scrollTop = 0;
    const figure = root.querySelector('.chapter-photo');
    figure.hidden = !item.image;
    if (item.image) {
      const image = root.querySelector('#chapter-image');
      image.src = item.image;
      image.alt = item.alt;
      image.style.objectPosition = item.position || 'center';
      figure.classList.toggle('contain', item.fit === 'contain');
      root.querySelector('#chapter-caption').textContent = item.caption;
    }
    nodes.forEach((node, i) => {
      node.classList.toggle('current', i === index);
      node.classList.toggle('passed', i < index);
      if (i === index) node.setAttribute('aria-current', 'step');
      else node.removeAttribute('aria-current');
    });
    previous.disabled = index === 0;
    next.disabled = index === items.length - 1;
  }
  function positionTrack(position, moving) {
    const gap = 176;
    const center = sceneBody.clientHeight * .5;
    track.style.setProperty('--node-gap', `${gap}px`);
    track.style.setProperty('--track-y', `${center - position * gap}px`);
    track.style.setProperty('--track-length', `${steps * gap}px`);
    track.style.setProperty('--fill-length', `${position * gap}px`);
  }
  function progress() {
    return Math.max(0, Math.min(items.length - 1, (headerHeight - journey.getBoundingClientRect().top) / range * steps));
  }
  function fitPhoto() {
    const figure = root.querySelector('.chapter-photo');
    if (figure.hidden) return;
    const image = root.querySelector('#chapter-image');
    image.style.height = '';
    const available = Math.max(0, sceneBody.clientHeight - 20);
    const otherContent = detail.scrollHeight - image.getBoundingClientRect().height + 2;
    // Give the photo the available space; long chapters remain scrollable from the top.
    image.style.height = Math.max(130, Math.min(260, available - otherContent)) + 'px';
  }
  function settle() {
    if (!interactive || touching) return;
    // Never move the document after a swipe: iOS momentum remains in charge.
    const position = progress();
    const index = Math.max(0, Math.min(items.length - 1, Math.round(position)));
    settledIndex = index;
    navigationTarget = null;
    render(index);
    positionTrack(index, false);
    scene.classList.remove('travelling');
    detail.removeAttribute('aria-hidden');
    detail.inert = false;
    track.inert = true;
    fitPhoto();
    root.querySelector('#chapter-announcement').textContent = `${items[index].date}. ${items[index].title}. Milestone ${index + 1} of ${items.length}.`;
  }
  function updateScroll() {
    raf = false;
    if (!interactive) return;
    const rect = journey.getBoundingClientRect();
    if (rect.top > headerHeight || rect.bottom < sceneHeight + headerHeight) {
      clearTimeout(timer);
      settle();
      return;
    }
    const pos = progress();
    scene.classList.add('travelling');
    detail.setAttribute('aria-hidden', 'true');
    detail.inert = true;
    track.inert = false;
    render(Math.round(pos));
    positionTrack(pos, true);
    clearTimeout(timer);
    timer = setTimeout(settle, 140);
  }
  function scheduleScroll() {
    if (!raf) { raf = true; requestAnimationFrame(updateScroll); }
  }
  function configure() {
    sizeCards();
    const width = root.getBoundingClientRect().width;
    const should = width <= 640 && !reduceMotion.matches && !staticMode && !window.Shopify?.designMode;
    headerHeight = Math.ceil(document.querySelector('sticky-header')?.getBoundingClientRect().height || 0);
    const footerHeight = Math.ceil(document.querySelector('.md-mnav')?.getBoundingClientRect().height || 0);
    const visibleHeight = Math.min(window.innerHeight, window.visualViewport?.height || window.innerHeight);
    const height = Math.max(240, Math.floor(visibleHeight - headerHeight - footerHeight));
    root.style.setProperty('--scene-top', headerHeight+'px');
    const layoutChanged = should !== interactive || Math.abs(width - lastWidth) > 1;
    const heightChanged = Math.abs(height - sceneHeight) > 1;
    if (!layoutChanged && !heightChanged) return;
    lastWidth = width;
    interactive = should;
    sceneHeight = height;
    // Browser toolbar expansion changes the usable height, not the chapter positions.
    if (layoutChanged) range = steps * Math.max(520, height * .95);
    root.classList.toggle('interactive', interactive);
    root.classList.toggle('static-mobile', width <= 640 && staticMode && !reduceMotion.matches);
    journey.style.setProperty('--scene-height', `${height}px`);
    journey.style.setProperty('--scroll-range', `${range}px`);
    clearTimeout(timer);
    if (interactive) { positionTrack(progress(), scene.classList.contains('travelling')); fitPhoto(); if (layoutChanged) settle(); }
  }
  function goTo(index) {
    if (!interactive) return;
    const top = window.scrollY + journey.getBoundingClientRect().top - headerHeight;
    navigationTarget = Math.max(0, Math.min(items.length - 1, index));
    const target = top + navigationTarget / steps * range;
    window.scrollTo({top: target, behavior: reduceMotion.matches ? 'instant' : 'smooth'});
  }
  nodes.forEach((node, index) => node.addEventListener('click', () => goTo(index)));
  previous.addEventListener('click', () => goTo(active - 1));
  next.addEventListener('click', () => goTo(active + 1));
  root.querySelector('.read-all').addEventListener('click', () => {
    const index = Math.max(0, active);
    staticMode = true;
    configure();
    entries[index].scrollIntoView({block:'start',behavior:'instant'});
  });
  root.querySelector('.return-interactive').addEventListener('click', () => {
    staticMode = false;
    configure();
    goTo(Math.max(0, active));
  });
  const previewButtons = [...root.querySelectorAll('[data-preview]')];
  previewButtons.forEach(button => button.addEventListener('click', () => {
    staticMode = false;
    root.classList.toggle('preview-mobile', button.dataset.preview === 'mobile');
    previewButtons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    configure();
    window.scrollTo({top:0,behavior:'instant'});
    settle();
  }));
  window.addEventListener('touchstart', () => { touching = true; clearTimeout(timer); }, {passive:true,signal});
  const endTouch = () => { touching = false; clearTimeout(timer); timer = setTimeout(settle,140); };
  window.addEventListener('touchend', endTouch, {passive:true,signal});
  window.addEventListener('touchcancel', endTouch, {passive:true,signal});
  window.addEventListener('scroll', scheduleScroll, {passive:true,signal});
  window.addEventListener('scrollend', () => { clearTimeout(timer); settle(); }, {passive:true,signal});
  window.visualViewport?.addEventListener('resize', configure, {signal});
  window.addEventListener('resize', configure, {signal});
  reduceMotion.addEventListener('change', configure, {signal});
  const observer = new ResizeObserver(configure);
  observer.observe(root);
  document.fonts.ready.then(() => { if(root.isConnected) { sizeCards(); fitPhoto(); } });
  this.cleanup = () => {abort.abort();observer.disconnect();clearTimeout(timer);};
  render(0);
  configure();
}
});
})();
